spApp.factory('striptags', [
  function () {
    const htmlReg = /<\/?([a-z][a-z0-9]*)\b[^>]*>?/gi;
    return (html) => html.replace(htmlReg, '').trim();
  }
]);
